import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getAccessToken } from './token-storage';

interface AuthState {
  isAuthenticated: boolean;
  isInitialized: boolean;
}

const initialState: AuthState = {
  isAuthenticated: !!getAccessToken(),
  isInitialized: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setAuthInitialized(state, action: PayloadAction<boolean>) {
      state.isInitialized = action.payload;
    },
  },
});

export const { setAuthenticated, setAuthInitialized } = authSlice.actions;
export default authSlice.reducer;
